import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useAppDispatch, useAppSelector } from "./useRedux";
import { clearPendingNavigate } from "../store/superuser/slice";
import { selectSuperuserPendingNavigate } from "../store/selectors/superuser";


export function useSuperuserNavigate(): void {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pendingPath = useAppSelector(selectSuperuserPendingNavigate);

  useEffect(() => {
    if (!pendingPath) return;
    navigate(pendingPath, { replace: true });
    dispatch(clearPendingNavigate());
  }, [pendingPath, navigate, dispatch]);
}
